export const formatDate = (dateString?: string) => {
  if (!dateString) return '-'
  const matches = dateString.match(/^\d{4}-\d{2}-\d{2}/)
  return matches ? matches[0] : dateString
}
